<template>
  <!-- 团队订单 -->
  <div class="container">
    <div v-if="!showGoodsDetails">
      <el-card shadow="never" id="teamGoods" style="min-height: 700px">
        <div id="resetInput" class="topHandle">
          <div class="search-box">
            <el-input class="box-item" clearable placeholder="输入订单编号" v-model="teamOrderListParams.orderCode" prefix-icon="el-icon-search" />
            <el-input class="box-item" clearable placeholder="输入预约检测设备" v-model="teamOrderListParams.equipmentName" prefix-icon="el-icon-search" />
            <el-input class="box-item" clearable placeholder="输入申请人" v-model="teamOrderListParams.clientName" prefix-icon="el-icon-search" />
            <el-date-picker
              class="box-item"
              v-model="dateList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeDate"
              >
            </el-date-picker>
            <div>
              <el-button @click="resetParams">重置</el-button>
              <el-button type="primary" @click="getSearch()">搜索</el-button>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="i in tabsList" :key="i.index" :label="i.label" :name="i.index.toString()">
            <div class="table_head">
              <div class="table_head_col" :style="{ width: i.width }" v-for="i in headList" :key="i.index">{{ i.name }}
              </div>
            </div>
            <div class="table_content" v-loading="loading">
              <el-empty v-if="tableData.length == 0" description="暂无订单"></el-empty>
              <div class="table_content_card" v-for="item in tableData" :key="item.index">
                <div class="table_card_head">
                  <span>下单时间：{{ item.orderDate || '-' }}</span>
                  <span>申请人：{{ item.clientName || '-' }}</span>
                  <span>订单号：{{ item.orderCode || '-' }}</span>
                  <span>客户经理：{{ item.clientManager || '-' }}({{ item.clientManagerPhoneNumber || '-' }})</span>
                </div>
                <div class="table_card_body" @click="toDetails(item)">
                  <div class="table_body_name">
                    <div>
                      <el-image
                        :src="(item.fileList && item.fileList.length) > 0 ? imgurl + item.fileList[0].url : '../../assets/img/morentupian.png'"
                        class="goodsequipImg">
                        <div slot="error">
                          <img class="goodsequipImg" src="../../assets/img/morentupian.png" />
                        </div>
                      </el-image>
                    </div>
                    <div>{{ item.equipmentName }}</div>
                  </div>
                  <div class="table_body_othername">{{ dictFilter(item.prepaidPayment ? item.prepaidPayment.toString() :
                    '-', 'prepaidPayment') }}</div>
                  <div class="table_body_othername">¥{{ item[selectMoneyKey(item)] }}</div>
                  <div class="table_body_othername font14666">
                    <div>
                      <span>{{ orderStatusToString(item) }}</span>
                      <el-tooltip v-if="orderStatusToString(item) == '待核对'" effect="dark" content="需要申请人到个人订单核对，才能下载实验结果" placement="top">
                        <i class="el-icon-warning" style="color: #FF4A2B;"></i>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="table_body_othername font14666">
                    <el-tooltip v-if="orderStatusToString(item) == '已完成'" class="item" effect="light" content="无需开票：预存支付的订单，包括团队预存和个人预存" placement="top">
                      <svg-icon icon-class="tips" v-if="item.billStatus === 3" style="margin-right: 3px"/>
                      <span>{{ dictFilter(item.billStatus ? item.billStatus.toString() : '-', 'invoiceOrderStatus') }}</span>
                    </el-tooltip>
                    <span v-else>--</span> 
                  </div>
                  <div class="table_body_btn">
                    <div class="clickName" v-if="orderStatusToString(item) == '待审核'" @click.stop="checkOrder(item.orderId, 3)">拒绝</div>
                    <div class="clickName" v-if="orderStatusToString(item) == '待审核'" @click.stop="checkOrder(item.orderId, 2)">通过</div>
                    <div class="clickName" v-if="orderStatusToString(item) == '已完成' && item.billStatus == 2 && item.prepaidPayment != 1 && item.prepaidPayment != 2" @click.stop="openInvoice(item.orderId)">查看发票</div>
                    <div class="clickName" v-if="orderStatusToString(item) == '已完成' || orderStatusToString(item) == '回运'" @click.stop="fileHandle(item)">下载实验结果</div>
                    <!-- <div class="clickName" v-if="orderStatusToString(item) == '已完成' && item.prepaidPayment == 6 " @click.stop="rePayment(item)">立即还款</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div class="total-money">
                <span>累计检测金额： </span>
                <span style="margin-right: 8px; color: #FF4A2B;">￥{{ totalCost }} </span>
              </div>
              <el-pagination background v-if="total > 0" style="text-align: right;margin-top: 10px"
                layout="total,prev, pager, next,sizes,jumper" :current-page="teamOrderListParams.pageNum"
                :page-size="teamOrderListParams.pageSize" :total="total" @current-change="selPageChange"
                @size-change="handleSizeChange">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>

    <!-- 订单详情 -->
    <goodsDetails ref="goodsDetails" v-if="showGoodsDetails" @close="getList"></goodsDetails>
    <!-- 复制实验结果链接弹框 -->
    <el-dialog title="提示" :visible.sync="downloadFileListDialog" width="40%">
      <div class="downloadfile-title">存在多个实验结果的订单，下载实验数据时，需手动<span style="color: #FF4A2B; font-weight: 600;">点击</span>复制相应数据链接，前往浏览器粘贴打开以下载！</div>
      <div class="file-link" v-for="(item, index) in downloadFileList" :key="index" @click="copyLink(item)">{{ item }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadFileListDialog = false">关  闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import goodsDetails from "./goodsDetails";
import { teamOrderList, orderInfo, getDownLoadUrl, orderCheck, getOrderInvoiceInfo } from "@/api/request";
import { getClient } from "@/plugins/auth";
import { moneyKey, orderStatus } from "@/utils/order.js"

export default {
  components: {
    goodsDetails,
  },
  data() {
    return {
      loading: false,
      activeName: "0",
      showGoodsDetails: false,
      imgurl: process.env.VUE_APP_FILE_API,
      userInfo: JSON.parse(getClient()),
      teamId: undefined,
      total: 0,
      totalCost: 0,
      downloadFileList: [],//实验结果下载链接 列表
      downloadFileListDialog: false,//实验结果下载链接  弹框
      dateList: [],
      teamOrderListParams: {
        teamId: null,
				pageSize: 10,
				pageNum: 1,
				noStatuss: '1',
        orderCode: '',
        equipmentName: '',
        clientName: '',
        orderDateBegin: '',
        orderDateEnd: '',
      },
      headList: [
        { name: "检测项目", index: 1, width: "200px" },
        { name: "支付方式", index: 2, width: "80px" },
        { name: "应付款", index: 3, width: "80px" },
        { name: "订单状态", index: 4, width: "80px" },
        { name: "发票状态", index: 5, width: "80px" },
        { name: "操作", index: 6, width: "170px" }
      ],
      tableData: [],
      tabsList: [
        {label: '全部订单', index: 0},
				{label: '待审核', index: 1, value: 10},
				{label: '待寄样/取样', index: 2},
				{label: '已寄样/取样', index: 3},
				{label: '待实验', index: 4, value: 4},
				{label: '实验中', index: 5, value: 5},
				{label: '待核对', index: 6, value: 12},
				{label: '已取消', index: 7, value: 8},
				{label: '售后/回运', index: 8},
				{label: '已完成', index: 9},
				{label: '申请开票', index: 10, value: 9},
      ]
    };
  },
  created() {
    this.teamId = JSON.parse(getClient()).teamId
    this.teamOrderListParams.teamId = this.teamId
  },
  mounted() {
    let obj = this.$route.query
    if (obj && obj.orderCode) {
      this.teamOrderListParams.orderCode = obj.orderCode
    }
    this.getList()
  },
  methods: {
    // 翻译订单状态
		orderStatusToString(data) {
			return orderStatus(data)
		},
    //分情况选择金额展示字段
		selectMoneyKey(data) {
			return moneyKey(data)
		},
    //查询订单列表
    getList() {
      this.showGoodsDetails = false;
      this.loading = true
      teamOrderList(this.teamOrderListParams).then(res => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
        this.totalCost = res.data.data.teamStat
        this.loading = false
      });
    },
    //重置筛选条件
    resetParams() {
      this.dateList = []
      this.teamOrderListParams = {
        teamId: this.teamId,
        pageNum: 1,
        pageSize: 10,
      }
      const tab = { 
        name: this.activeName,
      }
      this.handleClick(tab)
    },
    //切换tab栏
    handleClick(tab) {
      const { teamId, orderCode, equipmentName, clientName, orderDateBegin, orderDateEnd } = this.teamOrderListParams
      this.teamOrderListParams = {
				teamId,
        orderCode,
        equipmentName,
        clientName,
        orderDateBegin,
        orderDateEnd,
				pageSize: 10,
				pageNum: 1,
			}
      if(tab.name == 0) {
				this.teamOrderListParams.noStatuss = '1'
				this.getList()
				return
			}
      const data = this.tabsList.find(item => item.index == tab.name)
			if(data.index == 2) {
				this.teamOrderListParams.customWaitStatus = true
				this.getList()
				return
			}
			if(data.index == 3) {
				this.teamOrderListParams.customHasStatus = true
				this.getList()
				return
			}
			if(data.index == 8) { 
				this.teamOrderListParams.status = 7
				this.teamOrderListParams.customBackStatus = true
				this.getList()
				return
			}
			if(data.index == 9) {
				this.teamOrderListParams.status = 7
				this.teamOrderListParams.noAfterSalesStatus = '1'
				this.teamOrderListParams.noRecycleStatus = '2'
				this.getList()
				return
			}
			this.teamOrderListParams.status = data.value
			this.getList()
    },
    //订单详情
    toDetails(item) {
      this.showGoodsDetails = true;
      this.$nextTick(()=> {
        this.$refs.goodsDetails.getOrderInfo(item.orderId)
      })
    },
    selPageChange(page) {
      this.teamOrderListParams.pageNum = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.teamOrderListParams.pageSize = val;
      this.getList();
    },
    getSearch() {
      this.teamOrderListParams.pageNum = 1
      this.getList()
    },
    changeDate(e) {
      this.teamOrderListParams.orderDateBegin = e ? e[0] : ''
      this.teamOrderListParams.orderDateEnd = e ? e[1] : ''
    },
    // 审核订单
		checkOrder(order_id, value) {
			const data = {
				orderId: order_id,
				checkStatus: value,
			}
      this.$confirm(`是否确认${value == 2 ? '通过' : '拒绝'}该订单审核`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await orderCheck(data)
        this.getList()
      })
		},
    // 查看订单发票
		async openInvoice(orderId) {
      const res = await getOrderInvoiceInfo({orderId: orderId})
      const file_path = this.imgurl + res.data.invoiceFileList[0].url
      window.open(file_path)
		},
    //下载实验结果
    async fileHandle(data) {
      this.loading = true
      const orderInfoRes = await orderInfo(data.orderId)
      const getFileList = orderInfoRes.data.experimentalDataList.map(item => {
        const obj = {
          key: item.url,
          attname: item.name
        }
        return getDownLoadUrl(obj)
      })
      const promiseRes = await Promise.all(getFileList)
      this.downloadFileList = promiseRes.map(item => {
        return item.msg
      })
      this.loading = false
      if (this.downloadFileList.length == 1) {
        this.$confirm("确认是否下载实验数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          window.open(this.downloadFileList[0])
        });
      } else if (this.downloadFileList.length > 1) {
        this.downloadFileListDialog = true
      } else {
        this.$message.error("暂无可下载实验数据");
      }
    },
    //复制实验结果链接
    async copyLink(url) {
      try {
        await navigator.clipboard.writeText(url);
        this.$message.success('复制成功！')
      } catch {
        this.$message.error('写入剪贴板失败！')
      }
    },
  }
};
</script>
<style>
#teamGoods .el-card__body {
  padding: 10px 35px;
}

#teamGoods .el-tabs__content {
  overflow: inherit;
}
</style>

<style scoped lang="scss">
.container {
  width: 100%;
  height: calc(100vh - 200px);
}
.topHandle {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  gap: 15px;
  width: 100%;
  .search-box {
    display: flex;
    gap: 10px;
    width: 100%;
    .box-item {
      display: flex;
      width: calc((100% - 40px) / 5);
    }
  }
}

.goodsequipImg {
  width: 80px;
  height: 56px;
  border-radius: 12px;
  margin-right: 5px;
}

.table_head {
  display: flex;
  flex-flow: row nowrap;
  background: #f5f5f5;
  text-align: center;
  justify-content: space-around;
  border-radius: 7px;
  margin: 20px 0;
  color: #111111;
  font-size: 14px;
  padding: 20px;
}

.table_content {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 450px);
}
.table_content_card {
  cursor: pointer;
  margin-bottom: 20px;
  border-radius: 7px;
  border: 1px solid #e0e2ff;
}

.table_card_head {
  font-size: 14px;
  color: #666;
  background: #eaeffa;
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
  border-bottom: 1px solid #e0e2ff;

  span {
    margin-right: 50px;
  }
}

.table_card_body {
  position: relative;
  padding: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: #111;
}

.table_body_name {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 200px;
  text-align: left;
}

.table_body_othername {
  width: 80px;
}

.table_body_btn {
  width: 170px;
  display: flex;
  flex-flow: column;
}

.total-money {
  display: flex;
  align-items: center;
}

.downloadfile-title {
  font-size: 14px;
}

.file-link {
  cursor: pointer;
  margin-top: 10px;
  padding: 10px;
  text-decoration: underline;
  color: #5D5D5D;
  border: 1px solid #E8E8E8;
}
.file-link:hover {
  color: #5CC300;
}
</style>